import React from 'react';
import styled from 'styled-components';
import format from 'date-fns/format';
const DateStyle = styled.span `
  position: static;
`;
const DateComponent = ({ className, date, formatType }) => {
    return (React.createElement(DateStyle, { className: `Date ${className || ''}` }, date &&
        format(new Date(parseInt(date, 10)), formatType || 'dd-MM-yyyy, HH:mm')));
};
export default DateComponent;
